import { jsxs as F, jsx as s } from "react/jsx-runtime";
import * as S from "react";
import { forwardRef as ce, useRef as m, useMemo as L, useCallback as o, useEffect as h, useImperativeHandle as ue } from "react";
import n from "./style.module.less.js";
import O from "./send-arrow.svg.js";
import pe from "./attach-plus.svg.js";
import { FileChip as fe } from "./file-chip/index.js";
import { massageFilename as j } from "../../../utils/massage-filename.js";
import { MakeMeShiny as de } from "./shiny-border.js";
const he = ce((K, z) => {
  const {
    id: A,
    onSendMessage: D,
    className: q,
    inputsClassName: G,
    chatInputClassName: J,
    disabled: i,
    disableFileInput: M,
    failedFiles: y,
    onInput: Q,
    placeholder: U,
    sendOnEnter: k,
    shiny: V = !1,
    chatInputRef: X,
    externalMessage: c,
    setExternalMessage: d,
    classNames: a,
    autoFocus: E = !0,
    truncateOnBlur: B,
    onFocus: Y,
    onBlur: Z,
    preTextIcon: C
  } = K, b = m(null), [g, v] = S.useState(""), x = L(() => c ?? g, [g, c]), w = o(
    (e) => {
      d ? d(e) : v(e);
    },
    [d]
  );
  h(() => {
    c != null && v(c);
  }, [c]);
  const $ = m(null), [r, l] = S.useState([]), H = m(null), _ = m(null), ee = m(null), p = S.useRef(null), N = o(
    async (e = void 0) => {
      var t;
      if (e == null || e.preventDefault(), e == null || e.stopPropagation(), !i)
        try {
          (t = p.current) == null || t.focus(), await D({ text: x, files: r }), w(""), l([]);
        } catch {
        }
    },
    [i, x, r, D, w]
  ), te = o(
    (e) => {
      k && e.key === "Enter" && !e.shiftKey && (e.preventDefault(), N());
    },
    [k, N]
  ), R = () => {
    const e = p.current;
    e && (e.style.height = "auto", e.style.height = `${e.scrollHeight}px`), e && H.current && (e.style.height = "auto", e.style.height = `${e.scrollHeight}px`);
  };
  h(() => (window.addEventListener("resize", R), () => {
    window.removeEventListener("resize", R);
  }), []), h(() => {
    R();
  }, [x]);
  const ne = (e) => {
    e.preventDefault(), $.current && $.current.click();
  }, re = o(
    (e) => {
      var f;
      const t = (f = e.clipboardData) == null ? void 0 : f.items;
      if (t) {
        const T = [];
        for (let I = 0; I < t.length; I++)
          if (t[I].kind === "file") {
            const W = t[I].getAsFile();
            W && T.push(W);
          }
        T.length && (l([...r, ...T]), e.preventDefault());
      }
    },
    [r, l]
  ), ae = o(
    (e) => {
      if ($.current) {
        const t = e.map(j);
        l([...r, ...t]);
      }
    },
    [r]
  );
  ue(
    z,
    () => ({
      ...b.current,
      // Spread the HTMLDivElement properties
      inputContainerRef: b,
      addFiles: ae,
      setMessage: v,
      focusTextarea: () => {
        var e;
        return (e = p.current) == null ? void 0 : e.focus();
      },
      blurTextarea: () => {
        var e;
        return (e = p.current) == null ? void 0 : e.blur();
      }
    })
  );
  const se = o(
    (e) => {
      const t = [...r];
      t.splice(e, 1), l(t);
    },
    [r, l]
  );
  h(() => {
    var e;
    i ? (w(""), l([])) : (e = p.current) == null || e.focus({
      preventScroll: !0
    });
  }, [w, i]);
  const ie = o(
    (e) => {
      const t = Array.from(e.target.files ?? []).map(j);
      l((f) => [...f, ...t]);
    },
    []
  );
  h(() => {
    y && l((e) => e.filter((t) => !y.includes(t)));
  }, [y]), h(() => {
    var e;
    E && !i && ((e = p.current) == null || e.focus({ preventScroll: !0 }));
  }, [E, i]);
  const le = o(
    (e) => {
      e.preventDefault(), e.stopPropagation();
      const t = e.target.value;
      i || (d ? d(t) : v(t));
    },
    [i, d]
  ), u = L(() => c ?? g, [c, g]), oe = o((e) => {
    const t = e.trimStart();
    if (!t) return "";
    const f = t.indexOf(`
`);
    return f === -1 ? t : t.substring(0, f) + "...";
  }, []), P = /* @__PURE__ */ F(
    "div",
    {
      className: `${n.chatInput} ${i ? n.disabled : ""} ${J ?? ""} ${(a == null ? void 0 : a.chatInput) ?? ""}`,
      id: "chat-input",
      ref: b,
      children: [
        /* @__PURE__ */ s(
          "input",
          {
            ref: $,
            type: "file",
            className: n.fileInput,
            multiple: !0,
            onChange: ie,
            disabled: i
          }
        ),
        C ? /* @__PURE__ */ s("img", { src: C, className: n.preTextIcon }) : null,
        /* @__PURE__ */ F(
          "div",
          {
            ref: _,
            className: `${n.actions} ${r && (r == null ? void 0 : r.length) > 0 ? n.overlapping : ""}`,
            children: [
              M ? null : /* @__PURE__ */ s("button", { className: n.attachButton, onClick: ne, children: /* @__PURE__ */ s(pe, {}) }),
              /* @__PURE__ */ s(
                "button",
                {
                  className: `${n.sendButton} ${x.trim() || (r == null ? void 0 : r.length) > 0 ? n.hasText : ""}`,
                  onClick: N,
                  id: "send-button",
                  "aria-label": "send-button",
                  children: /* @__PURE__ */ F("div", { className: n.sendArrowImageWrapper, children: [
                    /* @__PURE__ */ s("div", { className: n.sendArrowWrapperHover, children: /* @__PURE__ */ s(O, { className: n.sendArrow }) }),
                    /* @__PURE__ */ s("div", { className: n.sendArrowWrapper, children: /* @__PURE__ */ s(O, { className: n.sendArrow }) })
                  ] })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ F(
          "div",
          {
            ref: H,
            className: `${n.inputs} ${M ? n.noFiles : ""} ${G ?? ""} ${(a == null ? void 0 : a.inputContainer) ?? ""}`,
            children: [
              B && (u == null ? void 0 : u.length) > 0 ? /* @__PURE__ */ s("div", { className: n.truncateOnBlurContainer, children: oe(u) }) : null,
              /* @__PURE__ */ s(
                "textarea",
                {
                  id: A ?? "chat-input-textarea",
                  ref: p,
                  className: `${n.textareaInput} ${B && (u == null ? void 0 : u.length) > 0 ? n.withTruncate : ""} ${C ? n.withPreTextIcon : ""} ${(a == null ? void 0 : a.textarea) ?? ""}`,
                  value: u,
                  onChange: le,
                  onKeyDown: te,
                  rows: 1,
                  placeholder: U ?? void 0,
                  onPaste: re,
                  onInput: Q,
                  onFocus: Y,
                  onBlur: Z
                },
                A ?? "chat-input-textarea"
              ),
              r && (r == null ? void 0 : r.length) > 0 && !i ? /* @__PURE__ */ s("div", { ref: ee, className: n.files, children: r.map((e, t) => /* @__PURE__ */ s(
                fe,
                {
                  filename: e.name,
                  removeFile: () => se(t)
                },
                e.name
              )) }) : null
            ]
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ s(
    "div",
    {
      className: `${n.chatInputContainer} ${(a == null ? void 0 : a.container) ?? ""} ${q ?? ""}`,
      ref: X,
      children: V ? /* @__PURE__ */ s(de, { className: (a == null ? void 0 : a.shinyInput) ?? "", children: P }) : P
    }
  );
});
he.displayName = "ChatInput";
export {
  he as ChatInput
};
